export default "__VITE_ASSET__Cpov4IN2__"